import React from 'react';
import Button from './button';

export default function Primary(props) {
  return <Button variant="primary" {...props} />;
}
